// Mock data for the static website

export const companyInfo = {
  name: "Target For Health Consulting",
  nameArabic: "تارجت للاستشارات الصحية",
  tagline: "Where the success of your health establishment is our Target",
  taglineArabic: "حيث نجاح مؤسستك الصحية هو هدفنا",
  phone: "02 6221300, 056 747 7759",
  fax: "026221302",
  email: "queries@targethealth.ae",
  address: "UAE, Abu Dhabi, Al Morour road, Al Nahyan Camp, Al Mamoura street, Al Saada Tower, Office 1102",
  addressArabic: "الإمارات العربية المتحدة، أبوظبي، شارع المرور، مخيم النهيان، شارع المعمورة، برج السعادة، مكتب 1102",
  description: "TARGET FOR HEALTH CONSULTING is a limited liability corporation established in 2017 in the Emirate of Abu Dhabi under a permit from the UAE Department of Economic Development to function as a health consulting and planning company.",
  descriptionArabic: "تارجت للاستشارات الصحية هي شركة ذات مسؤولية محدودة تأسست في عام 2017 في إمارة أبوظبي بموجب ترخيص من دائرة التنمية الاقتصادية بدولة الإمارات العربية المتحدة للعمل كشركة استشارات وتخطيط صحي."
};

export const services = [
  {
    id: 1,
    title: "Claims Consulting",
    shortDescription: "Review and assess the medical claims randomly or periodically. Provide advisory support to the clinical team to grant...",
    fullDescription: "Review and assess the medical claims randomly or periodically. Provide advisory support to the clinical team to grant appropriate medical services according to the patient's condition and benefits. Confirm the accuracy of the medical claims processing and the correctness of the CPT and ICD-10 coding and modifiers. Review denied claims and provide advisory support to re-submit if applicable.",
    icon: "FileText"
  },
  {
    id: 2,
    title: "Medical Records Consulting",
    shortDescription: "Qualify and train your staff on how to collect, document, save, archive and re-call the medical information and the...",
    fullDescription: "Qualify and train your staff on how to collect, document, save, archive and re-call the medical information and the health records according to the local health authority guidelines and international standards. Review and assess the applied documentation systems and recommend proper improvements to enhance the quality of the medical records management.",
    icon: "FolderOpen"
  },
  {
    id: 3,
    title: "Insured Patients",
    shortDescription: "Provide advisory support to all patients regarding the medical insurance system and their benefits and exclusions,...",
    fullDescription: "Provide advisory support to all patients regarding the medical insurance system and their benefits and exclusions, pre-authorizations and approvals required before accessing the healthcare services. Assist patients in understanding their insurance coverage and help them navigate through the complexities of the healthcare insurance system.",
    icon: "Users"
  },
  {
    id: 4,
    title: "Data Analysis Consulting",
    shortDescription: "Provide advisory support for the establishment's growth and performance according to the health market demands and...",
    fullDescription: "Provide advisory support for the establishment's growth and performance according to the health market demands and requirements. Analyze healthcare data to identify trends, patterns, and opportunities for improvement. Generate comprehensive reports and insights to support strategic decision-making and operational excellence.",
    icon: "BarChart3"
  },
  {
    id: 5,
    title: "Admin Consulting",
    shortDescription: "Review and assess applied policies and procedures and optimize them to meet the local health authority guidelines and to...",
    fullDescription: "Review and assess applied policies and procedures and optimize them to meet the local health authority guidelines and to meet international standards. Develop and implement efficient administrative systems and workflows. Provide training and support to administrative staff to ensure compliance and operational efficiency.",
    icon: "Settings"
  },
  {
    id: 6,
    title: "Technical Consulting",
    shortDescription: "Qualify your staff by supplying them with information and experiences which were designed on high standard levels to...",
    fullDescription: "Qualify your staff by supplying them with information and experiences which were designed on high standard levels to meet the local and international requirements. Provide technical expertise in healthcare systems, equipment, and technology implementation. Support digital transformation initiatives in healthcare facilities.",
    icon: "Laptop"
  },
  {
    id: 7,
    title: "Events Management",
    shortDescription: "Establishing, organizing and managing any type of medical events, seminars, work-shops and conferences. Very far beyond...",
    fullDescription: "Establishing, organizing and managing any type of medical events, seminars, workshops and conferences. We handle everything from venue selection to speaker coordination, registration management, and post-event follow-up. Our team ensures professional execution of healthcare events that deliver value to all participants.",
    icon: "Calendar"
  },
  {
    id: 8,
    title: "CME & Medical Staff Training",
    shortDescription: "CME covering wide range of medical and dental specialties will be one of our concerns to assist the healthcare...",
    fullDescription: "CME covering wide range of medical and dental specialties will be one of our concerns to assist the healthcare professionals in maintaining their professional competence. We offer accredited continuing medical education programs designed by experts to keep healthcare professionals updated with the latest medical knowledge and best practices.",
    icon: "GraduationCap"
  },
  {
    id: 9,
    title: "Elite Services",
    titleArabic: "الخدمات المتميزة",
    shortDescription: "Elevate your healthcare facility to new heights of excellence with our comprehensive suite of professional services...",
    shortDescriptionArabic: "ارتقِ بمؤسستك الصحية إلى آفاق جديدة من التميز مع مجموعتنا الشاملة من الخدمات الاحترافية...",
    fullDescription: `Elevate your healthcare facility to new heights of excellence with our comprehensive suite of professional services. Designed for forward-thinking healthcare organizations, our elite solutions combine advanced analytics, strategic insights, and proven methodologies to optimize your operations, maximize revenue, and ensure sustainable growth in today's competitive healthcare landscape.

📊 KPI Management & Performance Optimization
Transform data into actionable insights. We establish, monitor, and optimize key performance indicators tailored to your facility's unique goals, ensuring measurable improvements in clinical outcomes, operational efficiency, and patient satisfaction.

💰 Clinical Costing & Financial Intelligence
Gain complete visibility into your cost structure. Our detailed clinical costing analysis helps you understand true service costs, optimize resource allocation, and make informed pricing decisions that enhance profitability without compromising quality.

🔄 Rejections Solutions & Claims Recovery
Minimize revenue leakage through intelligent claims management. We analyze rejection patterns, implement preventive strategies, and establish robust appeal processes to maximize your reimbursement rates and reduce claim denials.

📈 Revenue Cycle Analysis & Optimization
Unlock hidden revenue opportunities. Our comprehensive revenue analysis identifies bottlenecks, streamlines billing processes, and implements best practices to accelerate cash flow and improve your bottom line.

🛡️ Risk Management & Compliance Assurance
Protect your organization with proactive risk mitigation. We assess clinical, operational, and financial risks, develop customized mitigation strategies, and ensure full compliance with local and international healthcare regulations.

Partner with us to transform your healthcare facility into a high-performing, financially resilient organization that delivers exceptional patient care while achieving operational excellence.`,
    fullDescriptionArabic: `ارتقِ بمؤسستك الصحية إلى آفاق جديدة من التميز مع مجموعتنا الشاملة من الخدمات الاحترافية. مصممة خصيصاً للمؤسسات الصحية الطموحة، حلولنا المتميزة تجمع بين التحليلات المتقدمة والرؤى الاستراتيجية والمنهجيات المثبتة لتحسين عملياتك وتعظيم الإيرادات وضمان النمو المستدام في بيئة الرعاية الصحية التنافسية اليوم.

📊 إدارة مؤشرات الأداء الرئيسية وتحسين الأداء
حوّل البيانات إلى رؤى قابلة للتنفيذ. نقوم بإنشاء ومراقبة وتحسين مؤشرات الأداء الرئيسية المصممة خصيصاً لأهداف مؤسستك الفريدة، مما يضمن تحسينات قابلة للقياس في النتائج السريرية والكفاءة التشغيلية ورضا المرضى.

💰 التكلفة السريرية والذكاء المالي
احصل على رؤية كاملة لهيكل التكاليف الخاص بك. يساعدك تحليل التكلفة السريرية المفصل لدينا على فهم التكاليف الحقيقية للخدمات وتحسين تخصيص الموارد واتخاذ قرارات تسعير مستنيرة تعزز الربحية دون المساس بالجودة.

🔄 حلول الرفض واسترداد المطالبات
قلل من تسرب الإيرادات من خلال الإدارة الذكية للمطالبات. نقوم بتحليل أنماط الرفض وتنفيذ استراتيجيات وقائية وإنشاء عمليات استئناف قوية لتعظيم معدلات السداد وتقليل رفض المطالبات.

📈 تحليل وتحسين دورة الإيرادات
اكتشف فرص الإيرادات الخفية. يحدد تحليل الإيرادات الشامل لدينا نقاط الاختناق ويبسط عمليات الفوترة وينفذ أفضل الممارسات لتسريع التدفق النقدي وتحسين النتيجة النهائية.

🛡️ إدارة المخاطر وضمان الامتثال
احمِ مؤسستك من خلال التخفيف الاستباقي للمخاطر. نقوم بتقييم المخاطر السريرية والتشغيلية والمالية، وتطوير استراتيجيات تخفيف مخصصة، وضمان الامتثال الكامل للوائح الرعاية الصحية المحلية والدولية.

شاركنا لتحويل مؤسستك الصحية إلى منظمة عالية الأداء ومرنة مالياً تقدم رعاية استثنائية للمرضى مع تحقيق التميز التشغيلي.`,
    icon: "Award"
  }
];

export const heroSlides = [
  {
    id: 1,
    image: "https://i2.ae/media/1001/banner2.jpg",
    title: "Target For Health Consulting",
    subtitle: "Where the success of your health establishment is our Target"
  },
  {
    id: 2,
    image: "/brochure-english.png",
    title: "Medical Insurance Coordinator Training",
    subtitle: "Professional Training Program - English"
  },
  {
    id: 3,
    image: "/brochure-arabic.png",
    title: "دورة منسق التأمين الطبي",
    subtitle: "برنامج تدريبي احترافي - عربي"
  },
  {
    id: 4,
    image: "https://customer-assets.emergentagent.com/job_legacy-upgrade-6/artifacts/7va1fzi0_logo%20multiple.jpg",
    title: "Certified Training Centre",
    subtitle: "Accredited by ACTVET, Department of Health & Economic Development"
  }
];

export const events = [
  {
    id: 1,
    title: "Healthcare Leadership Summit 2024",
    date: "March 15, 2024",
    location: "Abu Dhabi Convention Center",
    description: "Join healthcare leaders and industry experts for a comprehensive summit focused on the future of healthcare management and innovation.",
    image: "https://images.pexels.com/photos/7446988/pexels-photo-7446988.jpeg?w=800&q=80"
  },
  {
    id: 2,
    title: "Medical Claims Processing Workshop",
    date: "April 22, 2024",
    location: "Target Health Office, Abu Dhabi",
    description: "An intensive workshop covering best practices in medical claims processing, coding accuracy, and denial management.",
    image: "https://images.pexels.com/photos/5998477/pexels-photo-5998477.jpeg?w=800&q=80"
  },
  {
    id: 3,
    title: "Healthcare Data Analytics Conference",
    date: "May 10, 2024",
    location: "Dubai Healthcare City",
    description: "Learn how to leverage data analytics to improve patient outcomes and operational efficiency in healthcare settings.",
    image: "https://images.unsplash.com/photo-1576091160550-2173dba999ef?w=800&q=80"
  }
];

export const cmes = [
  {
    id: 1,
    title: "Advanced Cardiac Life Support (ACLS)",
    credits: "8 CME Credits",
    duration: "2 Days",
    description: "Comprehensive ACLS training program covering emergency cardiovascular care for healthcare professionals.",
    category: "Emergency Medicine"
  },
  {
    id: 2,
    title: "Diabetes Management Update",
    credits: "4 CME Credits",
    duration: "1 Day",
    description: "Latest evidence-based approaches to diabetes diagnosis, treatment, and patient education.",
    category: "Endocrinology"
  },
  {
    id: 3,
    title: "Infection Control in Healthcare Settings",
    credits: "6 CME Credits",
    duration: "1.5 Days",
    description: "Essential training on infection prevention and control measures in healthcare facilities.",
    category: "Public Health"
  },
  {
    id: 4,
    title: "Pediatric Emergency Care",
    credits: "8 CME Credits",
    duration: "2 Days",
    description: "Specialized training in managing pediatric emergencies and critical care situations.",
    category: "Pediatrics"
  },
  {
    id: 5,
    title: "Medical Ethics and Patient Rights",
    credits: "3 CME Credits",
    duration: "0.5 Day",
    description: "Understanding ethical principles and patient rights in modern healthcare practice.",
    category: "Medical Ethics"
  },
  {
    id: 6,
    title: "Healthcare Leadership and Management",
    credits: "5 CME Credits",
    duration: "1 Day",
    description: "Developing leadership skills for effective healthcare management and team coordination.",
    category: "Healthcare Management"
  }
];

export const clients = [
  {
    id: 1,
    name: "Abu Dhabi Health Services",
    logo: "https://via.placeholder.com/200x80/0891b2/ffffff?text=ADHS"
  },
  {
    id: 2,
    name: "Emirates Medical Center",
    logo: "https://via.placeholder.com/200x80/0891b2/ffffff?text=EMC"
  },
  {
    id: 3,
    name: "Al Noor Hospital",
    logo: "https://via.placeholder.com/200x80/0891b2/ffffff?text=Al+Noor"
  },
  {
    id: 4,
    name: "Dubai Healthcare City",
    logo: "https://via.placeholder.com/200x80/0891b2/ffffff?text=DHCC"
  },
  {
    id: 5,
    name: "HealthPlus Clinic",
    logo: "https://via.placeholder.com/200x80/0891b2/ffffff?text=HealthPlus"
  },
  {
    id: 6,
    name: "Medical Center Group",
    logo: "https://via.placeholder.com/200x80/0891b2/ffffff?text=MCG"
  }
];



// CME Courses - Easy to manage and update
export const cmeCourses = {
  // Active/Current Courses - These will be displayed prominently
  active: [
    {
      id: 1,
      title: "Medical Insurance Coordinator Training",
      titleArabic: "دورة منسق التأمين الطبي",
      description: `Kickstart Your Career in Medical Insurance!

Why Join This Course?
• 12 Certified Training Hours (3 hours/day over 4 days)
• Hands-on Practical + Theoretical Training on real clinic systems
• Accredited Certificate to boost your professional profile
• Job-Oriented Skills aligned with the medical market needs

What You Will Learn:
• Fundamentals of Medical Insurance
• How to Verify Patient Eligibility Efficiently
• Submission & Follow-up of Medical Approvals
• Key Duties of a Medical Insurance Coordinator

Limited Time – Invest in Your Future Today!`,
      descriptionArabic: `ابدأ مستقبلك في مجال التأمين الطبي من اليوم!

ليش تسجل معنا؟
•	12 ساعة تدريبية معتمدة (3 ساعات يومياً لمدة 4 أيام) 
•	تدريب عملي + نظري على أنظمة عيادات حقيقية 
•	شهادة معتمدة تقوّي سيرتك الذاتية 
•	مهارات مطلوبة فعلياً في سوق العمل الطبي

وش راح تتعلم؟
•	أساسيات التأمين الطبي بطريقة سهلة وواضحة 
•	كيف تتحقق من أهلية المرضى بسرعة واحترافية 
•	طريقة تقديم ومتابعة الموافقات الطبية 
•	مهام منسق التأمين الطبي خطوة بخطوة

لا تفوّت الفرصة – الأماكن محدودة! سجّل الحين وابدأ طريقك المهني بثقة!`,
      duration: "4 Days",
      durationArabic: "4 أيام",
      credits: "Accredited Training Certificate",
      creditsArabic: "شهادة تدريب معتمدة",
      category: "Insurance Management",
      startDate: "",
      endDate: "",
      location: "Abu Dhabi, UAE",
      locationArabic: "أبوظبي، الإمارات",
      videoUrl: "https://customer-assets.emergentagent.com/job_legacy-upgrade-6/artifacts/crw8r58k_WhatsApp%20Video%202026-03-18%20at%201.24.21%20PM.mp4",
      brochures: [
        {
          title: "English Brochure",
          url: "https://customer-assets.emergentagent.com/job_legacy-upgrade-6/artifacts/mk1nz2jg_Brochure%20E%20%D9%85%D9%86%D8%B3%D9%82%20%D8%AA%D8%A3%D9%85%D9%8A%D9%86%20%D8%B7%D8%A8%D9%8A.pdf",
          language: "en"
        },
        {
          title: "النشرة العربية",
          url: "https://customer-assets.emergentagent.com/job_legacy-upgrade-6/artifacts/n68hnmc2_Brochure%20%20A%20%D9%85%D9%86%D8%B3%D9%82%20%D8%AA%D8%A3%D9%85%D9%8A%D9%86%20%D8%B7%D8%A8%D9%8A%20%20%20.pdf",
          language: "ar"
        }
      ],
      registrationLink: "#registration",
      status: "active",
      featured: true
    },
    {
      id: 2,
      title: "Healthcare Quality Management & Accreditation",
      titleArabic: "إدارة الجودة الصحية والاعتماد",
      description: `Master Healthcare Quality Standards & Accreditation!

Why This Course Matters?
• 5 Days Intensive Training (4 hours/day)
• Learn International Accreditation Standards (JCI, CBAHI, ISO)
• Practical Tools for Quality Improvement
• Official Certification upon completion

What You'll Master:
• Healthcare Quality Management Principles
• Accreditation Process & Documentation
• Clinical Audit & Patient Safety Protocols
• Performance Measurement & KPI Tracking
• Risk Management in Healthcare Settings

Transform your healthcare facility with quality excellence!`,
      descriptionArabic: `أتقن معايير الجودة الصحية والاعتماد!

لماذا هذه الدورة مهمة؟
• 5 أيام تدريب مكثف (4 ساعات يومياً)
• تعلم معايير الاعتماد الدولية (JCI, CBAHI, ISO)
• أدوات عملية لتحسين الجودة
• شهادة رسمية عند الإكمال

ما ستتقنه:
• مبادئ إدارة الجودة الصحية
• عملية الاعتماد والتوثيق
• التدقيق السريري وبروتوكولات سلامة المرضى
• قياس الأداء وتتبع مؤشرات الأداء الرئيسية
• إدارة المخاطر في المنشآت الصحية

حوّل منشأتك الصحية بتميز الجودة!`,
      duration: "5 Days",
      durationArabic: "5 أيام",
      credits: "Professional Development Certificate",
      creditsArabic: "شهادة تطوير مهني",
      category: "Quality Management",
      startDate: "",
      endDate: "",
      location: "Dubai, UAE",
      locationArabic: "دبي، الإمارات",
      image: "https://images.pexels.com/photos/7108344/pexels-photo-7108344.jpeg?w=600&q=80",
      videoUrl: "https://www.youtube.com/embed/dQw4w9WgXcQ",
      brochures: [
        {
          title: "Course Brochure - English",
          url: "#",
          language: "en"
        },
        {
          title: "كتيب الدورة - عربي",
          url: "#",
          language: "ar"
        }
      ],
      registrationLink: "#registration",
      status: "active",
      featured: true
    },
    {
      id: 3,
      title: "Emergency Response & Crisis Management",
      titleArabic: "الاستجابة للطوارئ وإدارة الأزمات",
      description: `Be Prepared for Healthcare Emergencies!

Course Highlights:
• 3 Days Comprehensive Training
• Real-life Emergency Simulation Exercises
• Crisis Communication Strategies
• Emergency Response Team Building
• Accredited Crisis Management Certificate

Training Modules:
• Emergency Preparedness Planning
• Incident Command System (ICS)
• Mass Casualty Management
• Hospital Emergency Operations Center (HEOC)
• Post-Crisis Evaluation & Continuous Improvement

Protect Lives, Save Your Organization!`,
      descriptionArabic: `كن مستعداً لحالات الطوارئ الصحية!

ميزات الدورة:
• 3 أيام تدريب شامل
• تمارين محاكاة للطوارئ الواقعية
• استراتيجيات التواصل في الأزمات
• بناء فريق الاستجابة للطوارئ
• شهادة إدارة الأزمات المعتمدة

وحدات التدريب:
• تخطيط التأهب للطوارئ
• نظام قيادة الحوادث (ICS)
• إدارة الإصابات الجماعية
• مركز عمليات الطوارئ بالمستشفى (HEOC)
• التقييم بعد الأزمة والتحسين المستمر

احمِ الأرواح، أنقذ مؤسستك!`,
      duration: "3 Days",
      durationArabic: "3 أيام",
      credits: "Emergency Management Certificate",
      creditsArabic: "شهادة إدارة الطوارئ",
      category: "Emergency Management",
      startDate: "",
      endDate: "",
      location: "Abu Dhabi, UAE",
      locationArabic: "أبوظبي، الإمارات",
      image: "https://images.pexels.com/photos/6814456/pexels-photo-6814456.jpeg?w=600&q=80",
      videoUrl: "https://www.youtube.com/embed/dQw4w9WgXcQ",
      brochures: [
        {
          title: "Download Brochure",
          url: "#",
          language: "en"
        },
        {
          title: "تحميل الكتيب",
          url: "#",
          language: "ar"
        }
      ],
      registrationLink: "#registration",
      status: "active",
      featured: true
    }
  ],
  
  // Previous/Past Courses - Archive
  previous: [
    {
      id: 'prev-1',
      title: "Advanced Cardiac Life Support (ACLS)",
      titleArabic: "دعم الحياة القلبي المتقدم",
      description: "Comprehensive training in advanced cardiovascular emergency care and resuscitation.",
      descriptionArabic: "تدريب شامل في رعاية طوارئ القلب والأوعية الدموية المتقدمة والإنعاش.",
      notes: "Successfully completed with 45 healthcare professionals. Included hands-on simulation training.",
      notesArabic: "تم إكماله بنجاح مع 45 متخصصاً في الرعاية الصحية. تضمن تدريباً عملياً بالمحاكاة.",
      duration: "2 Days",
      durationArabic: "يومان",
      credits: "16 CME Credits",
      creditsArabic: "16 ساعة تعليم طبي مستمر",
      completedDate: "December 2024",
      completedDateArabic: "ديسمبر 2024",
      location: "Abu Dhabi, UAE",
      locationArabic: "أبوظبي، الإمارات",
      image: "https://images.pexels.com/photos/7108344/pexels-photo-7108344.jpeg?w=400&q=80",
      category: "Emergency Medicine"
    },
    {
      id: 'prev-2',
      title: "Infection Control & Prevention",
      titleArabic: "مكافحة العدوى والوقاية منها",
      description: "Essential protocols for preventing healthcare-associated infections.",
      descriptionArabic: "البروتوكولات الأساسية للوقاية من العدوى المرتبطة بالرعاية الصحية.",
      notes: "Attended by 60+ medical staff. Updated with latest WHO guidelines.",
      notesArabic: "حضره أكثر من 60 من الطاقم الطبي. محدث بأحدث إرشادات منظمة الصحة العالمية.",
      duration: "1 Day",
      durationArabic: "يوم واحد",
      credits: "6 CME Credits",
      creditsArabic: "6 ساعات تعليم طبي مستمر",
      completedDate: "November 2024",
      completedDateArabic: "نوفمبر 2024",
      location: "Dubai, UAE",
      locationArabic: "دبي، الإمارات",
      image: "https://images.pexels.com/photos/4031867/pexels-photo-4031867.jpeg?w=400&q=80",
      category: "Infection Control"
    },
    {
      id: 'prev-3',
      title: "Clinical Documentation Excellence",
      titleArabic: "التميز في التوثيق السريري",
      description: "Best practices in medical record documentation and compliance.",
      descriptionArabic: "أفضل الممارسات في توثيق السجلات الطبية والامتثال.",
      notes: "Practical workshop with real case studies. Certificate of completion awarded.",
      notesArabic: "ورشة عمل عملية مع دراسات حالة حقيقية. تم منح شهادة إتمام.",
      duration: "3 Days",
      durationArabic: "3 أيام",
      credits: "12 CME Credits",
      creditsArabic: "12 ساعة تعليم طبي مستمر",
      completedDate: "October 2024",
      completedDateArabic: "أكتوبر 2024",
      location: "Abu Dhabi, UAE",
      locationArabic: "أبوظبي، الإمارات",
      image: "https://images.pexels.com/photos/4386466/pexels-photo-4386466.jpeg?w=400&q=80",
      category: "Medical Records"
    },
    {
      id: 'prev-4',
      title: "Patient Safety & Quality Improvement",
      titleArabic: "سلامة المرضى وتحسين الجودة",
      description: "Strategies for enhancing patient safety and healthcare quality.",
      descriptionArabic: "استراتيجيات لتعزيز سلامة المرضى وجودة الرعاية الصحية.",
      notes: "Interactive sessions with group activities. Highly rated by participants.",
      notesArabic: "جلسات تفاعلية مع أنشطة جماعية. حصلت على تقييم عالٍ من المشاركين.",
      duration: "2 Days",
      durationArabic: "يومان",
      credits: "10 CME Credits",
      creditsArabic: "10 ساعات تعليم طبي مستمر",
      completedDate: "September 2024",
      completedDateArabic: "سبتمبر 2024",
      location: "Sharjah, UAE",
      locationArabic: "الشارقة، الإمارات",
      image: "https://images.pexels.com/photos/8460165/pexels-photo-8460165.jpeg?w=400&q=80",
      category: "Quality Management"
    }
  ],

  // Future/Upcoming Courses
  future: [
    {
      id: 'future-1',
      title: "Healthcare Data Analytics & AI",
      titleArabic: "تحليلات البيانات الصحية والذكاء الاصطناعي",
      description: "Leveraging data analytics and artificial intelligence in modern healthcare.",
      descriptionArabic: "الاستفادة من تحليلات البيانات والذكاء الاصطناعي في الرعاية الصحية الحديثة.",
      notes: "Covers predictive analytics, machine learning applications, and data visualization. Early bird discount available.",
      notesArabic: "يغطي التحليلات التنبؤية وتطبيقات التعلم الآلي وتصور البيانات. خصم الحجز المبكر متاح.",
      duration: "3 Days",
      durationArabic: "3 أيام",
      credits: "15 CME Credits",
      creditsArabic: "15 ساعة تعليم طبي مستمر",
      plannedDate: "April 2026",
      plannedDateArabic: "أبريل 2026",
      location: "Abu Dhabi, UAE",
      locationArabic: "أبوظبي، الإمارات",
      image: "https://images.pexels.com/photos/8849295/pexels-photo-8849295.jpeg?w=400&q=80",
      category: "Healthcare Technology",
      status: "planning"
    },
    {
      id: 'future-2',
      title: "Telemedicine & Digital Health",
      titleArabic: "الطب عن بُعد والصحة الرقمية",
      description: "Best practices in telehealth delivery and virtual patient care.",
      descriptionArabic: "أفضل الممارسات في تقديم الرعاية الصحية عن بُعد ورعاية المرضى الافتراضية.",
      notes: "Includes hands-on training with telemedicine platforms. Limited to 30 participants.",
      notesArabic: "يتضمن تدريباً عملياً على منصات الطب عن بُعد. محدود بـ 30 مشاركاً.",
      duration: "2 Days",
      durationArabic: "يومان",
      credits: "12 CME Credits",
      creditsArabic: "12 ساعة تعليم طبي مستمر",
      plannedDate: "May 2026",
      plannedDateArabic: "مايو 2026",
      location: "Dubai, UAE",
      locationArabic: "دبي، الإمارات",
      image: "https://images.pexels.com/photos/5863389/pexels-photo-5863389.jpeg?w=400&q=80",
      category: "Digital Health",
      status: "planning"
    },
    {
      id: 'future-3',
      title: "Revenue Cycle Management Mastery",
      titleArabic: "إتقان إدارة دورة الإيرادات",
      description: "Optimizing healthcare revenue cycle from patient registration to payment collection.",
      descriptionArabic: "تحسين دورة الإيرادات الصحية من تسجيل المرضى إلى تحصيل المدفوعات.",
      notes: "Advanced techniques for reducing claim denials and improving cash flow. Case study based learning.",
      notesArabic: "تقنيات متقدمة لتقليل رفض المطالبات وتحسين التدفق النقدي. التعلم على أساس دراسة الحالة.",
      duration: "4 Days",
      durationArabic: "4 أيام",
      credits: "20 CME Credits",
      creditsArabic: "20 ساعة تعليم طبي مستمر",
      plannedDate: "June 2026",
      plannedDateArabic: "يونيو 2026",
      location: "Abu Dhabi, UAE",
      locationArabic: "أبوظبي، الإمارات",
      image: "https://images.pexels.com/photos/7681091/pexels-photo-7681091.jpeg?w=400&q=80",
      category: "Healthcare Finance",
      status: "planning"
    }
  ]
};
